import { render, staticRenderFns } from "./Actors.vue?vue&type=template&id=47bb2653&scoped=true&"
import script from "./Actors.vue?vue&type=script&lang=js&"
export * from "./Actors.vue?vue&type=script&lang=js&"
import style0 from "./Actors.vue?vue&type=style&index=0&id=47bb2653&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb2653",
  null
  
)

export default component.exports